import React, { useContext } from 'react';
import { applicationContext } from 'helpers/services';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import NavBar from './NavBar';


const useStyles = makeStyles()((theme: Theme) => ({
    content: {
        marginLeft: 8,
        marginRight: 8,
        marginTop: 8,
        marginBottom: 8,
        [theme.breakpoints.down('lg')]: {
            marginLeft: 8,
            marginRight: 8,
        },
    }
}));

let SimecLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { classes } = useStyles();

    let appService = useContext(applicationContext);


    return (
        <>
            {appService.isLoading === false &&
                <>
                    <NavBar />
                    <div className={classes.content}>
                        {children}
                    </div>
                </>
            }
        </>
    );
}

export default SimecLayout;